export enum TabView {
  PLATFORM = "platform",
  CAMPAIGN = "campaign",
  ADSET = "adset",
  AD = "ad",
}
